import { render, staticRenderFns } from "./StrainNoteModal.template.vue?vue&type=template&id=e34dbe38&scoped=true&"
var script = {}
import style0 from "./StrainNoteModal.template.vue?vue&type=style&index=0&id=e34dbe38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34dbe38",
  null
  
)

export default component.exports